import { TESTIMONIALS as TESTIMONIALS_FALLBACK } from "@/data";
import { Reveal, Overline } from "@/components/Reveal";
import { useCollection } from "@/hooks/useCollection";
import { Star, Quote } from "lucide-react";

export const Testimonials = () => {
  const { data: TESTIMONIALS } = useCollection("testimonials", "/testimonials", TESTIMONIALS_FALLBACK);
  return (
    <section id="testimoni" className="bg-cream py-24 md:py-36 px-6 md:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="max-w-2xl mb-16">
          <Reveal>
            <Overline>Testimoni</Overline>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-ink">
              Dipercaya keluarga di seluruh Jawa Timur.
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.id || t.name} delay={i * 0.08}>
              <figure
                data-testid={`testimonial-${i}`}
                className="relative h-full rounded-3xl bg-cream-200 border border-border/50 p-8 md:p-10"
              >
                <Quote className="text-honey/40 mb-5" size={38} />
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: t.rating }).map((_, s) => (
                    <Star key={s} size={16} className="fill-honey text-honey" />
                  ))}
                </div>
                <blockquote className="text-lg md:text-xl text-ink leading-relaxed font-display italic mb-6">
                  “{t.text}”
                </blockquote>
                <figcaption className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-honey text-ink font-bold">
                    {t.name.charAt(0)}
                  </span>
                  <div>
                    <div className="font-semibold text-ink">{t.name}</div>
                    <div className="text-sm text-stone2">{t.city}</div>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
